import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanLoad,
  Route,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(public authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.getAuthenticated().pipe(
      map(user => {
        this.authService.currentUser.next(user);
        let roles = [];
        if (next.data && Object.keys(next.data).length !== 0) {
          roles = next.data.roles;
        }
        const hasRole = this.authService.hasRoles(roles) ? true : false;
        if (user) {
          return hasRole ? true : this.redirect(true);
        } else {
          this.redirect(false);
        }
      })
    );
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  redirect(auth: boolean): false {
    auth ? this.router.navigate(['/forbidden']) : this.router.navigate(['/login']);
    return false;
  }

  /* canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): boolean {

      // console.log(next);
      // console.log(state);
      if (this.auth.authenticated) {
        return true;
      } else {
        if (state.url !== '/login') {
          this.router.navigate(['/login']);
        }
        return false;
      }
  } */
}
